import {ActionTypes, CCAuthorizedAxios, CCAxios} from './../../cc-imports'

const Actions = {
    getUser: (authDetails)=> {
        return {
            type: ActionTypes.GET_USER,
            payload: CCAuthorizedAxios(authDetails).get('/user/userId/' + authDetails.userId + '/')
        }
    },
    getUserByEmail: (authDetails)=> {
        return {
            type: ActionTypes.GET_USER,
            payload: CCAuthorizedAxios(authDetails).get('/user/email/' + authDetails.email + '/')
        }
    },
    getOrCreateUserByEmail: (user, accessToken)=> {
        return {
            type: ActionTypes.GET_OR_CREATE_USER,
            payload: CCAuthorizedAxios({accessToken}).post('/user/email/' + user.email + '/', user)
        }
    },
    fbUserNotFound: ()=> {
        return {
            type: ActionTypes.FB_USER_NOT_FOUND
        }
    },
    signUpUser: (user)=> {
        return {
            type: ActionTypes.SIGN_UP_USER,
            payload: CCAxios.post('/user/', user)
        }
    },
    updateShowHelp: (user)=> {
        return {
            type: ActionTypes.UPDATE_SHOW_HELP,
            payload: CCAxios.post('/user/update/userId/' + user.id + '/', {helped: true})
        }
    },
    updatePhoneNumber: (user)=> {
        return {
            type: ActionTypes.UPDATE_PHONE_NUMBER,
            payload: CCAxios.post('/user/update/userId/' + user.id + '/', {phone: user.phone})
        }
    },
    updateInvitedBy : (email,invitedBy) =>{
        return {
            type : ActionTypes.UPDATE_INVITED_BY,
            payload : CCAxios.post('/user/invitation/email/'+email+'/', {invitedBy:{id:invitedBy}})
        }
    },
    updateCountry : (user, country) => {
        return {
            type : ActionTypes.UPDATE_SETTINGS,
            payload : CCAxios.post('/user/update/userId/' + user.id + '/', {country:country})
        }
    },
    editionChanged : () => {
        return {
            type : ActionTypes.EDITION_CHANGED
        }
    },
    updateLanguage : (user, language) => {
        return {
            type : ActionTypes.UPDATE_SETTINGS,
            payload : CCAxios.post('/user/update/userId/' + user.id + '/', {language:language})
        }
    },
    updateSettings : (user, settings) => {
        return {
            type : ActionTypes.UPDATE_SETTINGS,
            payload : CCAxios.post('/user/update/userId/' + user.id + '/', {settings:settings})
        }
    },
    updateUser: (userId, user)=> {
        return {
            type: ActionTypes.UPDATE_USER,
            payload: CCAxios.post('/user/update/userId/' + userId + '/', user)
        }
    },
    signOutUser: ()=> {
        return {
            type: ActionTypes.SIGN_OUT_USER
        }
    },
    anonymousUserIn: ()=> {
        return {
            type: ActionTypes.ANONYMOUS_USER_IN
        }
    },
    saveFailedCredentials:(credentials)=>{
        return {
            type : ActionTypes.SAVE_FAILED_CREDENTIALS,
            payload : credentials
        }
    }
};

export default Actions



// WEBPACK FOOTER //
// ./src/app/data/actions/UserActions.js